(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ZZHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.zz-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.zz-hero__dot'));
      this.index = 0;
      this.delay = parseInt(this.dataset.autoplay || '5000', 10);
      if (this.slides.length <= 1) return;
      const prev = this.querySelectorAll('[data-zz-prev]');
      const next = this.querySelectorAll('[data-zz-next]');
      prev.forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      next.forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      let sx = null;
      this.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; this.stop(); }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        sx = null;
        this.start();
      }, { passive: true });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }
    go(i) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((s, j) => s.classList.toggle('is-active', j === this.index));
      this.dots.forEach((d, j) => d.classList.toggle('is-active', j === this.index));
    }
    start() {
      if (this.timer || this.delay < 1500) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }
    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    disconnectedCallback() {
      this.stop();
    }
  }
  if (!customElements.get('zz-hero')) {
    customElements.define('zz-hero', ZZHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
